import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ChevronRightIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey7', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.865 11.791l-5.84 6.069c-.09.093-.18.14-.292.14a.426.426 0 01-.291-.14l-.607-.63a.419.419 0 01-.135-.304c0-.117.045-.21.135-.303l4.918-5.112-4.918-5.134a.384.384 0 010-.584l.607-.654A.424.424 0 019.732 5c.114 0 .203.046.293.14l5.84 6.068a.382.382 0 010 .583z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=ChevronRight.js.map